import { AnimatePresence, motion } from "framer-motion";
import { Info } from "lucide-react";

interface WizardErrorProps {
    error: string;
}
const WizardError = ({ error }: WizardErrorProps) => (
    <AnimatePresence>
        {error && (
            <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg flex items-center space-x-2"
            >
                <Info className="w-5 h-5 text-red-500" />
                <span className="text-sm">{error}</span>
            </motion.div>
        )}
    </AnimatePresence>
);

export default WizardError;